
import type { GetAllAlertsPayload, GetAllAlerts, ExportAlertsPayload } from "../types/alerts.types";
import api from "@/services/apiClient";

export const alertService = {
  GetAllAlerts: (Payload: GetAllAlertsPayload, options?: { signal?: AbortSignal }): Promise<GetAllAlerts[]> =>
    api.post("Alerts/GetAllAlerts", Payload, { signal: options?.signal }).then((res) => res.data),
	ExportAlerts: (Payload: ExportAlertsPayload): Promise<Blob> => api.post("Alerts/ExportData", Payload, { responseType: "blob" }).then((res) => res.data),
};
